import _defineProperty from "/home/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getEventCoordinates } from '@dnd-kit/utilities';

function createSnapModifier(gridSize) {
  return function (_ref) {
    var transform = _ref.transform;
    return _objectSpread(_objectSpread({}, transform), {}, {
      x: Math.ceil(transform.x / gridSize) * gridSize,
      y: Math.ceil(transform.y / gridSize) * gridSize
    });
  };
}

var restrictToHorizontalAxis = function restrictToHorizontalAxis(_ref) {
  var transform = _ref.transform;
  return _objectSpread(_objectSpread({}, transform), {}, {
    y: 0
  });
};

function restrictToBoundingRect(transform, rect, boundingRect) {
  var value = _objectSpread({}, transform);

  if (rect.top + transform.y <= boundingRect.top) {
    value.y = boundingRect.top - rect.top;
  } else if (rect.bottom + transform.y >= boundingRect.top + boundingRect.height) {
    value.y = boundingRect.top + boundingRect.height - rect.bottom;
  }

  if (rect.left + transform.x <= boundingRect.left) {
    value.x = boundingRect.left - rect.left;
  } else if (rect.right + transform.x >= boundingRect.left + boundingRect.width) {
    value.x = boundingRect.left + boundingRect.width - rect.right;
  }

  return value;
}

var restrictToParentElement = function restrictToParentElement(_ref) {
  var containerNodeRect = _ref.containerNodeRect,
      draggingNodeRect = _ref.draggingNodeRect,
      transform = _ref.transform;

  if (!draggingNodeRect || !containerNodeRect) {
    return transform;
  }

  return restrictToBoundingRect(transform, draggingNodeRect, containerNodeRect);
};

var restrictToFirstScrollableAncestor = function restrictToFirstScrollableAncestor(_ref) {
  var draggingNodeRect = _ref.draggingNodeRect,
      transform = _ref.transform,
      scrollableAncestorRects = _ref.scrollableAncestorRects;
  var firstScrollableAncestorRect = scrollableAncestorRects[0];

  if (!draggingNodeRect || !firstScrollableAncestorRect) {
    return transform;
  }

  return restrictToBoundingRect(transform, draggingNodeRect, firstScrollableAncestorRect);
};

var restrictToVerticalAxis = function restrictToVerticalAxis(_ref) {
  var transform = _ref.transform;
  return _objectSpread(_objectSpread({}, transform), {}, {
    x: 0
  });
};

var restrictToWindowEdges = function restrictToWindowEdges(_ref) {
  var transform = _ref.transform,
      draggingNodeRect = _ref.draggingNodeRect,
      windowRect = _ref.windowRect;

  if (!draggingNodeRect || !windowRect) {
    return transform;
  }

  return restrictToBoundingRect(transform, draggingNodeRect, windowRect);
};

var snapCenterToCursor = function snapCenterToCursor(_ref) {
  var activatorEvent = _ref.activatorEvent,
      draggingNodeRect = _ref.draggingNodeRect,
      transform = _ref.transform;

  if (draggingNodeRect && activatorEvent) {
    var activatorCoordinates = getEventCoordinates(activatorEvent);

    if (!activatorCoordinates) {
      return transform;
    }

    var offsetX = activatorCoordinates.x - draggingNodeRect.left;
    var offsetY = activatorCoordinates.y - draggingNodeRect.top;
    return _objectSpread(_objectSpread({}, transform), {}, {
      x: transform.x + offsetX - draggingNodeRect.width / 2,
      y: transform.y + offsetY - draggingNodeRect.height / 2
    });
  }

  return transform;
};

export { createSnapModifier, restrictToFirstScrollableAncestor, restrictToHorizontalAxis, restrictToParentElement, restrictToVerticalAxis, restrictToWindowEdges, snapCenterToCursor };